<template>
  <div class="card">
    <div class="card__wrapper">
      <div class="card__content">
        <div class="card__hover-help"></div>
        <div class="card__image" :style="{'background-image': 'url(' + offer.image + ')'}">
          <div class="details">
            <span class="price">$ {{ offer.price }}</span>
            <button type="button round" class="button round"><chevron /></button>
          </div>
          <div class="description">
            <h4>{{ offer.region }}</h4>
            <h2>{{ offer.name }}</h2>
          </div>
        </div>
        <div class="card__details">
          <div class="card__toggle">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20"
              viewBox="0 0 24 24">
              <defs>
                <path id="a" d="M0 0h24v24H0V0z" />
              </defs>
              <clipPath id="b">
                <use xlink:href="#a" overflow="visible" />
              </clipPath>
              <path clip-path="url(#b)" d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
            </svg>
          </div>
          <div class="description">
            <h4>{{ offer.region }}</h4>
            <h2>{{ offer.name }}</h2>
          </div>
          <div class="pricing">
            <i title="King Size Bed">
              <svg viewBox="0 0 512 512" width="45px">
                <path
                  d="M457.106,274.303c0.703-1.426,1.11-3.022,1.11-4.717V253.92c0-10.756-8.752-19.507-19.509-19.507  h-12.86v-87.491c0-15.948-12.974-28.922-28.922-28.922H115.878c-15.948,0-28.922,12.975-28.922,28.922v87.491H73.279  c-10.757,0-19.508,8.751-19.508,19.507v15.666c0,1.695,0.407,3.294,1.112,4.72C40.106,278.307,29.2,291.826,29.2,307.852v46.687  c0,8.568,6.97,15.539,15.539,15.539h32.245v14.557c0,5.165,4.202,9.366,9.367,9.366h8.399c5.165,0,9.367-4.201,9.367-9.366v-14.557  h314.527v14.557c0,5.165,4.202,9.366,9.367,9.366h8.399c5.165,0,9.367-4.201,9.367-9.366v-14.557h21.481  c8.569,0,15.539-6.971,15.539-15.539v-46.687C482.8,291.822,471.889,278.3,457.106,274.303z M94.156,146.922  c0-11.978,9.744-21.722,21.722-21.722h281.048c11.979,0,21.723,9.745,21.723,21.722v86.574h-42.646v-9.549  c0-5.765-4.689-10.455-10.455-10.455h-75.09c-5.765,0-10.455,4.69-10.455,10.455v9.549h-47.2v-9.549  c0-5.765-4.69-10.455-10.454-10.455h-75.091c-5.766,0-10.455,4.69-10.455,10.455v9.549H94.156V146.922z M368.803,223.947v9.549  h-81.601v-9.549c0-1.794,1.46-3.255,3.255-3.255h75.09C367.342,220.692,368.803,222.153,368.803,223.947z M225.602,223.947v9.549  h-81.6v-9.549c0-1.794,1.46-3.255,3.255-3.255h75.091C224.142,220.692,225.602,222.153,225.602,223.947z M60.972,253.92  c0-6.786,5.521-12.307,12.308-12.307h365.429c6.786,0,12.309,5.521,12.309,12.307v15.666c0,1.931-1.57,3.502-3.502,3.502H64.474  c-1.932,0-3.502-1.571-3.502-3.502V253.92z M96.918,384.634c0,1.194-0.972,2.166-2.167,2.166h-8.399  c-1.195,0-2.167-0.972-2.167-2.166v-13.913h12.733V384.634z M438.579,384.634c0,1.194-0.972,2.166-2.167,2.166h-8.399  c-1.195,0-2.167-0.972-2.167-2.166v-13.913h12.733V384.634z M475.6,354.538c0,4.599-3.74,8.339-8.339,8.339H44.739  c-4.599,0-8.339-3.74-8.339-8.339v-46.687c0-15.193,12.36-27.555,27.555-27.555h37.282h309.525h37.281  c15.195,0,27.556,12.361,27.556,27.555V354.538z"
                  id="double_x5F_bed" /></svg>
            </i>
            <span class="price">$ <b>{{ offer.price }}</b> / night</span>
          </div>
          <div class="features">
            <div class="feature">
              <i>
                <svg viewBox="0 0 800 800" width="30px">
                  <g>
                    <path
                      d="M424.27,592.268c2.592,0.42,10.459,1.669,18.904,16.327c3.848,6.698,12.41,8.993,19.099,5.137   c6.689-3.855,8.991-12.41,5.128-19.106c-10.021-17.391-23.041-27.476-38.713-29.972c-32.798-5.246-65.674,24.18-94.631,50.139   c-11.333,10.163-22.034,19.765-29.441,23.917c-15.259,8.57-28.552,10.521-36.45,5.354c-1.64-1.076-2.826-2.31-3.637-3.496   c5.651-0.594,10.599-4.621,12.083-10.46c1.905-7.478-2.615-15.094-10.1-16.999c-14.377-3.669-24.056,2.996-28.31,10.443   c-6.4,11.193-3.099,27.333,7.845,38.371c3.949,3.98,14.868,12.924,33.102,12.924c10.576,0,23.61-3.012,39.159-11.737   c10.1-5.667,21.37-15.784,34.436-27.491C374.612,616.011,404.554,589.209,424.27,592.268z"
                      fill="#4D4D4D" />
                    <path
                      d="M580.739,594.345c2.585,0.421,10.452,1.67,18.897,16.327c3.855,6.696,12.426,8.991,19.106,5.137   c6.689-3.857,8.992-12.41,5.129-19.108c-10.022-17.389-23.05-27.474-38.722-29.972c-5.627-0.889-11.256-0.703-16.859,0.25   c0.14-153.371-0.289-239.99-0.905-289.179h183.313c7.728,0,13.986-6.26,13.986-13.987c0-7.719-6.259-13.987-13.986-13.987H566.949   c-0.688-34.218-1.469-36.91-1.953-38.573c-15.438-52.715-59.74-88.128-110.139-88.128l-5.347-0.031   c-59.069,0-107.336,56.284-110.248,126.733h-6.518c-7.727,0-13.987,6.268-13.987,13.987c0,7.727,6.26,13.987,13.987,13.987h206.682   c0.188,16.461,0.344,36.005,0.477,58.469H295.937c-0.031-109.062-0.733-112.411-1.171-114.51   c-12.113-58.079-58.522-98.635-112.77-98.635l-5.338-0.031c-59.085,0-107.346,56.284-110.256,126.733h-33.02   c-7.724,0-13.987,6.268-13.987,13.987c0,7.727,6.263,13.987,13.987,13.987h193.792c7.727,0,13.987-6.26,13.987-13.987   c0-7.719-6.26-13.987-13.987-13.987H94.359c2.717-55.018,38.535-98.759,82.212-98.759l5.347,0.031   c40.743,0,75.757,31.119,85.326,75.757c0.516,7.126,1.179,61.232,0.25,334.284l-0.009,3.902   c-30.681-0.858-61.185,26.43-88.276,50.719c-11.333,10.178-22.034,19.779-29.441,23.932c-15.26,8.553-28.552,10.506-36.458,5.339   c-1.647-1.094-2.826-2.327-3.646-3.497c5.659-0.61,10.608-4.638,12.091-10.475c1.904-7.477-2.623-15.096-10.116-17.001   c-14.361-3.651-24.041,2.999-28.302,10.445c-6.4,11.206-3.09,27.349,7.852,38.385c3.95,3.981,14.877,12.926,33.11,12.926   c10.568,0,23.603-3.014,39.15-11.725c10.1-5.665,21.378-15.781,34.437-27.504c21.886-19.606,51.905-46.441,71.527-43.35   c2.59,0.42,10.451,1.669,18.896,16.327c3.863,6.681,12.41,8.976,19.099,5.121c6.697-3.857,8.992-12.41,5.136-19.093   c-4.98-8.631-10.701-15.469-17.117-20.465l0.04-13.893c0.015-5.026,0.03-9.975,0.054-14.846h244.811   c0,8.147-0.017,16.375-0.017,24.758l-0.008,5.151c0,0.483,0.094,0.951,0.148,1.422c-17.374,10.02-34.226,25.068-49.93,39.15   c-11.333,10.162-22.033,19.762-29.434,23.914c-15.268,8.57-28.559,10.505-36.45,5.339c-1.654-1.076-2.825-2.311-3.645-3.481   c5.65-0.594,10.599-4.636,12.082-10.458c1.912-7.494-2.614-15.096-10.107-17.001c-14.377-3.667-24.041,2.983-28.302,10.428   c-6.4,11.193-3.106,27.336,7.845,38.372c3.948,3.979,14.868,12.94,33.108,12.926c10.577,0,23.604-2.999,39.159-11.725   c10.093-5.667,21.362-15.782,34.422-27.491C531.075,618.071,561.04,591.299,580.739,594.345z M367.221,249.826   c2.725-55.018,38.534-98.759,82.213-98.759l5.339,0.031c37.729,0,71.074,27.014,83.171,67.312   c0.407,3.465,0.766,14.213,1.078,31.416H367.221z M540.254,429.654H295.843c0.046-24.649,0.07-46.317,0.078-65.408h244.13   C540.138,384.29,540.208,406.129,540.254,429.654z M295.609,518.415c0.063-21.854,0.125-42.071,0.171-60.786h244.521   c0.031,19.309,0.038,39.588,0.038,60.786H295.609z"
                      fill="#4D4D4D" />
                    <path
                      d="M778.734,595.734c-10.021-17.392-23.057-27.477-38.721-29.975c-32.837-5.214-65.665,24.167-94.615,50.142   c-11.342,10.162-22.05,19.764-29.449,23.916c-15.267,8.554-28.552,10.506-36.45,5.339c-1.654-1.078-2.825-2.311-3.646-3.481   c5.659-0.593,10.607-4.62,12.091-10.46c1.905-7.492-2.623-15.094-10.108-16.998c-14.369-3.67-24.048,2.98-28.309,10.428   c-6.4,11.208-3.107,27.333,7.844,38.384c3.949,3.982,14.869,12.926,33.102,12.911c10.576,0,23.604-2.997,39.151-11.725   c10.107-5.667,21.386-15.781,34.452-27.488c21.87-19.624,51.92-46.472,71.526-43.351c2.583,0.421,10.444,1.67,18.89,16.328   c3.871,6.697,12.425,8.976,19.106,5.121C780.296,610.968,782.59,602.415,778.734,595.734z"
                      fill="#4D4D4D" />
                  </g>
                </svg>
              </i>
              <span>Pool</span>
            </div>
            <div class="feature">
              <i>
                <svg viewBox="0 0 800 800" width="30px">
                  <g>
                    <path
                      d="M365.171,537.668c-5.114-9.296-9.943-18.074-12.735-27.346c-11.798-39.219-11.765-82.273-10.696-123.014   c0.618-23.822,3.326-49.025,6.183-75.71c6.017-56.095,12.234-114.098-0.5-166.249c-10.596-43.434-48.098-72.618-93.304-72.618   c-7.103,0-14.289,0.748-21.341,2.222C147.813,92.69,68.447,169.792,48.142,254.297c-30.579,127.233,31.285,265.306,71.16,336.687   c22.662,51.219,71.294,136.284,144.092,136.284c11.632,0,23.448-2.231,35.129-6.635c50.371-18.998,87.671-76.696,84.88-131.35   C382.385,568.933,373.242,552.325,365.171,537.668z M287.944,692.615c-8.272,3.12-16.544,4.704-24.55,4.704   c-58.208,0-101.192-83.269-116.968-119.066c-0.2-0.435-0.401-0.865-0.635-1.278c-15.225-27.166-33.892-64.617-48.916-107.351   c2.557-2.892,75.773-85.457,134.749-116.279c25.904,10.868,50.672,27.266,50.939,27.446c6.885,4.579,16.177,2.716,20.756-4.161   c4.579-6.877,2.724-16.173-4.162-20.761c-1.27-0.853-31.703-21.037-62.871-32.907c-3.794-1.449-8.022-1.294-11.699,0.447   c-51.908,24.442-112.673,85.909-138.192,113.25c-1.589-5.633-3.092-11.322-4.496-17.063c0.668-1.023,1.337-2.063,1.755-3.271   c9.576-27.462,94.491-88.169,145.779-119.985c4.396-2.728,7.07-7.544,7.07-12.722v-94.022c0-8.268-6.701-14.974-14.974-14.974   c-8.255,0-14.975,6.706-14.975,14.974v85.733c-27.324,17.302-97.865,63.732-132.744,103.089   c-5.665-38.646-5.815-78.571,3.443-117.126c17.497-72.777,88.491-141.744,161.64-157.019c5.047-1.058,10.177-1.593,15.225-1.593   c31.135,0,56.938,20.009,64.208,49.777c11.498,47.062,5.565,102.417-0.184,155.95c-2.924,27.299-5.699,53.09-6.351,78.125   c-1.12,43.167-1.12,88.954,11.966,132.418c3.693,12.309,9.526,22.912,15.175,33.161c7.453,13.532,13.888,25.223,14.573,38.693   C355.628,632.51,326.215,678.184,287.944,692.615z"
                      fill="#4D4D4D" />
                    <path
                      d="M302.534,300.933c-18.717-15.935-36.799-25.449-37.568-25.846c-7.337-3.835-16.361-0.991-20.205,6.342   c-3.828,7.337-0.986,16.378,6.351,20.205c0.15,0.084,15.826,8.323,32.004,22.102c2.824,2.398,6.266,3.572,9.692,3.572   c4.245,0,8.457-1.788,11.415-5.268C309.586,315.743,308.818,306.296,302.534,300.933z"
                      fill="#4D4D4D" />
                    <path
                      d="M159.461,171.037c-42.114,19.548-68.136,79.049-74.502,126.059c-1.104,8.198,4.646,15.735,12.835,16.846   c0.685,0.092,1.37,0.134,2.038,0.134c7.371,0,13.805-5.453,14.807-12.969c6.284-46.375,30.968-90.626,57.423-102.905   c7.504-3.489,10.763-12.392,7.287-19.892C175.855,170.803,166.931,167.557,159.461,171.037z"
                      fill="#4D4D4D" />
                    <path
                      d="M304.975,557.435c4.579-6.891,2.707-16.182-4.178-20.762c-6.885-4.562-16.194-2.698-20.774,4.183   c-0.116,0.188-13.001,18.923-36.131,31.34c-20.055,9.409-40.494,12.718-40.895,12.779c-8.156,1.267-13.754,8.913-12.5,17.08   c1.153,7.4,7.52,12.698,14.79,12.698c0.752,0,1.521-0.059,2.306-0.185c1.002-0.154,24.851-3.924,49.736-15.625   C288.111,582.456,304.306,558.445,304.975,557.435z"
                      fill="#4D4D4D" />
                    <path
                      d="M315.436,596.152c-6.652-4.909-16.027-3.502-20.94,3.148c-0.1,0.144-10.746,14.098-28.779,22.441   c-15.141,5.79-30.015,6.706-30.215,6.715c-8.239,0.45-14.574,7.495-14.139,15.738c0.418,7.988,7.037,14.193,14.941,14.193   c0.268,0,0.535-0.014,0.802-0.026c0.802-0.041,19.92-1.119,39.859-8.856c0.268-0.104,0.535-0.213,0.785-0.335   c25.553-11.64,40.226-31.252,40.845-32.079C323.508,610.44,322.088,601.065,315.436,596.152z"
                      fill="#4D4D4D" />
                    <path
                      d="M751.856,254.297C731.567,169.792,652.186,92.69,567.221,74.955c-7.053-1.474-14.238-2.222-21.324-2.222   c-45.207,0-82.709,29.184-93.32,72.618c-12.735,52.15-6.52,110.154-0.502,166.249c2.874,26.685,5.582,51.888,6.2,75.71   c1.052,40.74,1.104,83.795-10.696,123.01c-2.791,9.275-7.637,18.054-12.752,27.35c-8.07,14.657-17.213,31.265-18.231,51.61   c-2.774,54.658,34.51,112.356,84.88,131.354c11.683,4.403,23.497,6.635,35.129,6.635c0,0,0,0,0.018,0   c72.781,0,121.413-85.065,144.075-136.284C720.571,519.603,782.439,381.53,751.856,254.297z M654.225,576.975   c-0.234,0.413-0.451,0.844-0.651,1.278c-15.777,35.802-58.744,119.075-116.97,119.066c-8.004,0-16.276-1.584-24.55-4.704   c-38.271-14.432-67.667-60.105-65.562-101.819c0.686-13.462,7.12-25.152,14.573-38.685c5.648-10.249,11.481-20.853,15.191-33.165   c12.1-40.223,12.969-82.412,12.148-122.701c1.99-0.293,3.961-0.974,5.767-2.106c0.485-0.3,45.308-28.29,74.252-40.769   c58.978,30.838,132.16,113.361,134.717,116.253C688.1,512.357,669.433,549.809,654.225,576.975z M713.602,436.66   c-25.519-27.342-86.284-88.809-138.175-113.25c-3.677-1.737-7.905-1.892-11.716-0.447c-23.814,9.067-60.13,30.404-76.676,40.427   c-0.518-7.383-1.135-14.877-1.854-22.448c21.894-20.238,68.637-37.31,87.104-43.527c51.423,32.079,134.582,91.741,144.059,118.911   c0.418,1.208,1.086,2.248,1.754,3.271C716.694,425.338,715.19,431.027,713.602,436.66z M726.203,378.417   c-34.895-39.357-105.421-85.787-132.761-103.089v-85.733c0-8.268-6.701-14.974-14.975-14.974c-8.272,0-14.974,6.706-14.974,14.974   v79.157c-16.262,5.432-54.063,19.152-81.872,37.402c-5.666-52.827-11.282-107.292,0.049-153.701   c7.27-29.765,33.073-49.774,64.226-49.774c5.047,0,10.161,0.535,15.208,1.593c73.149,15.274,144.158,84.241,161.64,157.019   C732.002,299.846,731.853,339.771,726.203,378.417z"
                      fill="#4D4D4D" />
                    <path
                      d="M693.381,227.795c-3.761-7.361-12.768-10.265-20.154-6.521c-7.37,3.765-10.279,12.785-6.519,20.151   c9.393,18.379,15.844,39.019,18.651,59.7c1.02,7.507,7.453,12.952,14.823,12.952c0.668,0,1.354-0.042,2.039-0.139   c8.188-1.115,13.921-8.661,12.818-16.857C711.73,272.759,704.427,249.45,693.381,227.795z"
                      fill="#4D4D4D" />
                    <path
                      d="M597.286,585.021c-8.975-1.571-18.166-3.986-27.292-7.187c-7.805-2.72-16.344,1.383-19.084,9.188   c-2.725,7.805,1.387,16.349,9.191,19.082c10.662,3.73,21.44,6.563,32.021,8.414c0.868,0.158,1.737,0.234,2.59,0.234   c7.152,0,13.47-5.131,14.739-12.4C610.873,594.205,605.425,586.45,597.286,585.021z"
                      fill="#4D4D4D" />
                    <path
                      d="M564.497,628.457c-0.151-0.009-15.058-0.916-30.217-6.715c-18.015-8.335-28.71-22.356-28.777-22.441   c-4.913-6.65-14.272-8.058-20.94-3.148c-6.651,4.913-8.056,14.288-3.141,20.939c0.601,0.827,15.274,20.439,40.827,32.079   c0.267,0.122,0.518,0.23,0.785,0.335c19.938,7.737,39.056,8.815,39.858,8.856c0.267,0.013,0.535,0.026,0.802,0.026   c7.889,0,14.49-6.184,14.925-14.165C579.07,635.98,572.736,628.928,564.497,628.457z"
                      fill="#4D4D4D" />
                  </g>
                </svg>
              </i>
              <span>Spa</span>
            </div>
            <div class="feature">
              <i>
                <svg viewBox="0 0 48 48" width="30px" height="30px">
                  
                        <path
                          d="M25,30c-0.256,0-0.512-0.098-0.707-0.293l-16-16c-0.286-0.286-0.372-0.716-0.217-1.09C8.23,12.243,8.596,12,9,12h32     c0.404,0,0.77,0.243,0.924,0.617c0.155,0.374,0.069,0.804-0.217,1.09l-16,16C25.512,29.902,25.256,30,25,30z M11.414,14     L25,27.586L38.586,14H11.414z" />
                      
                        <path d="M25,48c-0.553,0-1-0.447-1-1V29c0-0.553,0.447-1,1-1s1,0.447,1,1v18C26,47.553,25.553,48,25,48z" />
                      
                        <path d="M33,48H17c-0.553,0-1-0.447-1-1s0.447-1,1-1h16c0.553,0,1,0.447,1,1S33.553,48,33,48z" />
                      
                        <path
                          d="M14.293,13.707L9.051,8.465C8.106,7.521,6.851,7,5.515,7H0V5h5.515c1.87,0,3.628,0.729,4.95,2.051l5.242,5.242     L14.293,13.707z" />
                      
                        <path
                          d="M41,18c-1.291,0-2.552-0.354-3.648-1.023l1.043-1.707C39.177,15.747,40.077,16,41,16c2.757,0,5-2.243,5-5s-2.243-5-5-5     s-5,2.243-5,5c0,0.571,0.095,1.131,0.282,1.661l-1.885,0.666C34.134,12.583,34,11.8,34,11c0-3.859,3.141-7,7-7s7,3.141,7,7     S44.859,18,41,18z" />
                    
                  
                </svg>
              </i>
              <span>Bar</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card__actions">
        <rating class="rating" />
        <button class="button"><chevron /></button>
      </div>
    </div>
    <div class="card__hover-help"></div>
  </div>
</template>

<script>
import Chevron from './Chevron'
import Rating from './Rating'

export default {
  name: 'Card',
  components: {
    Chevron,
    Rating
  },
  props: {
    offer: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
$border-radius: 12px;
$helper-space: 20px;

$border-color: #f6f6f6;
$maxHeightTransition: max-height .3s cubic-bezier(0.075, 0.82, 0.165, 1);

.card {
  background: white;
  border-radius: $border-radius;
  box-shadow: 0 6px 12px rgba(0,0,0,.175);
  color: #636363;
  display: flex;
  min-height: 355px;
  min-width: 245px;
  position: relative;

  &__wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 1;
  }

  &__content,
  &__actions,
  &__image,
  &__details {
    height: 100%;
    overflow: hidden;
    position: relative;
    transition: $maxHeightTransition;
    will-change: max-height;
  }

  &__content,
  &__image {
    max-height: 100%;
    padding: 6px;
  }

  &__actions {
    align-items: center;
    border-top: 1px solid $border-color;
    display: flex;
    max-height: 0%;
    opacity: 0;
    transition: $maxHeightTransition .1s, opacity .3s ease-in-out .05s;
    will-change: max-height, opacity;
  }

  &__image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: #{$border-radius / 2};
    color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 12px 12px 24px;
    text-shadow: 0 0 12px rgba(0,0,0,0.98);
    transition-delay: 0s;
    z-index: 0;

    .details {
      align-items: center;
      display: flex;
      justify-content: flex-end;
      transition: opacity .2s ease-in-out, transform .3s ease-in-out;
    }

    .description {
      margin-top: auto;
      transition: opacity .2s ease-in-out;
      transition-delay: .25s;
    }
  }

  &__details {
    align-items: center;
    display: grid;
    grid-gap: 6px;
    grid-template-rows: repeat(3, 33.33%);
    max-height: 60%;
    overflow: visible;
    padding: 12px 12px 0;
    z-index: 1;

    .description,
    .pricing,
    .features {
      height: 100%;
    }

    .pricing,
    .features {
      opacity: 0;
      transition: opacity .3s ease-in-out;
    }
  }

  &:hover,
  &:focus-within {
    .card {
      &__content, {
        max-height: 85%;
      }

      &__actions {
        max-height: 15%;
        opacity: 1;
      }

      &__image {
        max-height: 75%;

        .description {
          opacity: 0;
          transition-delay: 0s;
        }
      }

      &__hover-help {
        pointer-events: all;
      }
    }
  }

  // Elements
  &__hover-help {
    bottom: -10px;
    left: -10px;
    pointer-events: none;
    position: absolute;
    right: -10px;
    top: -10px;
    z-index: 0;
  }

  &__content {
    .card__hover-help {
      height: 30%;
      top: auto;
      z-index: 2;

      &:hover,
      &:focus-within {
        height: 65%;

        & ~ .card__image {
          max-height: 40%;
          transition-delay: .2s;

          .details {
            opacity: 0;
            transform: translateY(-12px);
          }
        }

        & ~ .card__details {
          .pricing,
          .features {
            opacity: 1;
          }
        }
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  &__actions {
    .rating {
      padding: 12px;
    }

    .button {
      height: 100%;
      margin-left: auto;
      min-width: 50px;
      width: 10%;
    }
  }

  .pricing {
    border-bottom: 1px solid $border-color;
    border-top: 1px solid $border-color;

    i {
      height: 45px;
      margin-right: 12px;
    }
  }

  .pricing,
  .feature,
  .features {
    align-items: center;
    display: flex;

    i {
      margin-right: 4px;
    }
  }

  .feature {
    margin-right: 8px;
  }

  .price {
    font-size: 120%;
    font-weight: 600;
  }

  &__toggle {
    background: #ffffff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    cursor: pointer;
    height: 16px;
    left: 50%;
    max-width: 235px;
    position: absolute;
    text-align: center;
    top: -15px;
    transform: translateX(-50%);
    width: 50%;

    &::after,
    &::before {
      border-bottom: 1px solid #ffffff;
      bottom: -1px;
      content: '';
      height: 8px;
      overflow: hidden;
      position: absolute;
      width: 9px;
      z-index: 1;
    }

    &::after {
      border-left: 1px solid #ffffff;
      border-bottom-left-radius: 8px;
      box-shadow: -2px 2px 0 #ffffff;
      right: -8px;
    }

    &::before {
      border-right: 1px solid #ffffff;
      border-bottom-right-radius: 8px;
      box-shadow: 2px 2px 0 #ffffff;
      left: -8px,
    }

    svg {
      display: inline;
      fill: lightgray;
    }
  }
}
</style>